import styled, { css } from 'styled-components'

type IsMobile = {
  isMobile: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > button {
    width: 100%;
    max-width: 330px;
    border-radius: 30px;
    margin-top: 40px;
    margin-bottom: 10px;
  }

  p {
    line-height: 21px;
  }
`

export const Grid = styled.div<IsMobile>`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 250px 250px;
  gap: 60px;
  justify-content: center;

  ${({ isMobile }) => isMobile && css`
    grid-template-columns: 350px;
    gap: 25px;
  `}
`

export const GridItem = styled.div<IsMobile>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;

  & img {
    width: 100%;
    max-width: 250px;
  }

  ${({ isMobile }) => isMobile && css`
    & img {
      max-width: 300px;
    }

    & p {
      width: 300px;
      text-align: left;
    }
  `}
`